import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { CompetitorTracking } from '../types/marketing';

export const useCompetitors = () => {
  return useQuery({
    queryKey: ['competitors'],
    queryFn: async () => {
      const response = await api.get('/api/marketing/competitors/');
      return (response.data as any).results || response.data;
    },
  });
};

export const useCreateCompetitor = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (competitor: Partial<CompetitorTracking>) => {
      const response = await api.post('/api/marketing/competitors/', competitor);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['competitors'] });
    },
  });
};

export const useUpdateCompetitor = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, ...data }: Partial<CompetitorTracking> & { id: number }) => {
      const response = await api.patch(`/api/marketing/competitors/${id}/`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['competitors'] });
    },
  });
};

export const useDeleteCompetitor = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: number) => {
      const response = await api.delete(`/api/marketing/competitors/${id}/`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['competitors'] });
    },
  });
};